/**
 * Shared contract for the connector OAuth popup handshake.
 *
 * Lives in its own module (no React / context / firebase imports) so the
 * lightweight `/connectors/callback` bridge page can import it without
 * pulling in the full connectors hook + workspace context. The sender
 * (`ConnectorOAuthCallback`) and receiver (`useStartConnect`) both import
 * from here so the envelope can't drift.
 */

export const CONNECTOR_OAUTH_MESSAGE_TYPE = 'bower:connector-oauth' as const;
/**
 * Persists the provider tile that launched OAuth, so a full-page callback
 * (popup blocked) knows which card to finalize and whose failure reason to
 * read.
 */
export const CONNECTOR_OAUTH_TOOLKIT_STORAGE_KEY = 'bower:connector-oauth-toolkit' as const;

export interface ConnectorOAuthMessage {
  readonly type: typeof CONNECTOR_OAUTH_MESSAGE_TYPE;
  /** Composio appends `?status=success|failed`; anything else → 'failed'. */
  readonly status: 'success' | 'failed';
}
